import SwitchCircleIcon from '@assets/images/switch-circle-icon.svg?react'

import { Container, CircleContainer } from './SwitchButton.styled'

interface Props {
  disabled?: boolean
  selected?: boolean
  onClick?: () => void
}

export const SwitchButton = (props: Props): JSX.Element => {
  const { disabled, selected, onClick } = props

  return (
    <Container selected={selected} type="button" disabled={disabled} onClick={onClick}>
      <CircleContainer selected={selected}>
        <SwitchCircleIcon />
      </CircleContainer>
    </Container>
  )
}
